import { render } from "./irpi.vue?vue&type=template&id=2c5d9906&scoped=true"
import script from "./irpi.vue?vue&type=script&lang=js"
export * from "./irpi.vue?vue&type=script&lang=js"

import "./irpi.vue?vue&type=style&index=0&id=2c5d9906&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5d9906"]])

export default __exports__